const src = import.meta.ROLLUP_FILE_URL_6bp_5It$EfTQ8f$omStdjw;
export default {
  src,
  srcSet: src + " " + 4096 + "w",
  width: 4096,
  height: 2730,
};